import { Controller } from "stimulus"
import $ from 'jquery'
import Sortable from 'sortablejs'

export default class extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: '.handle',
      onEnd: this.end.bind(this)
    })
  }

  end(e) {
    $('.area-container').each(function(idx) {
      let inputField = $(this).find('.area-position')
      $(inputField).val(idx + 1);
    })
  }
}